<div class="data-table-wrapper">
    <div class="data-table">
        <div class="header-row">
            @for (column of columns; track column) {
<div class="header-cell" (click)="sortBy(column)">
                <span class="header-content">
                    {{ column.label }}
                    <span class="sort-icon">
                        @if (isSortedAsc(column)) {
<span><i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
}
                        @if (isSortedDesc(column)) {
<span><i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
}
                    </span>
                </span>
            </div>
}
            @if (showActions) {
<div class="header-cell actions-header">
                <span class="header-content">Actions</span>
            </div>
}
        </div>

        @if (sortedData.length === 0) {
<div class="row no-data-row">
            <div class="cell no-data-cell">
                No data to display
            </div>
        </div>
}

        @for (row of sortedData; track row) {
<div class="row" [attr.data-id]="'row-' + row.number">
            @for (column of columns; track column) {
<div class="cell">
                {{ row[column.value] }}
            </div>
}
            @if (showActions) {
<div class="cell actions-cell">
                <div class="action-buttons">
                    <button class="action-btn edit-btn" (click)="onEdit(row)" title="Edit" [disabled]="disableActions"
                        [attr.data-id]="'edit-' + row.number">
                        <i class="fa fa-edit"></i>
                    </button>
                    <button class="action-btn delete-btn" (click)="onDelete(row)" title="Delete"
                        [attr.data-id]="'delete-' + row.number" [disabled]="disableActions">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            </div>
}
        </div>
}
    </div>
</div>